"use client";

import { FootNotes } from "@/components/FootNotes/FootNotes.component";
import { PaywallCreateTrial } from "@/components/Paywall/_components/PaywallCreateTrial/PaywallCreateTrial.component";
import { PaywallLoginNotification } from "@/components/Paywall/_components/PaywallLoginNotification/PaywallLoginNotification.component";
import { PaywallTitle } from "@/components/Paywall/_components/PaywallTitle/PaywallTitle.component";
import { ProductsContainer } from "@/components/ProductsContainer/ProductsContainer.component";
import { useSite } from "@/contexts/site/site.context";
import { inlineJsx } from "@/ts/locale/inline-jsx";
type UnauthenticatedPaywallProps = {
  readonly position?: string;
};
export function UnauthenticatedPaywall(_props: UnauthenticatedPaywallProps) {
  const {
    name: siteName
  } = useSite();
  return <div className={"flex flex-col space-y-5 border-smoke border-t border-solid pt-5 text-center"} data-testid="unauthenticated-paywall">
      <PaywallLoginNotification />
      <PaywallTitle model={{
      da: inlineJsx`Få adgang til ${<em>hele</em>} ${siteName}`,
      de: inlineJsx`Erhalten Sie Zugang zu dem ${<em>gesamten</em>} ${siteName}`,
      en: inlineJsx`Get access to ${<em>all</em>} of ${siteName}`,
      no: inlineJsx`Få tilgang til ${<em>alt</em>} av ${siteName}`,
      sv: inlineJsx`Få tillgång till ${<em>allt</em>} från ${siteName}`
    }} />
      <ProductsContainer position="pw" promoPosition="paywall" variant="paywall" />

      <PaywallCreateTrial />

      <FootNotes />
    </div>;
}